interface Customer {
  id: string
  email: string
  status: string
  has_password: boolean
  total_orders_count: number
  shopper_reference: string
  created_at: string
  updated_at: string
  metadata: Record<string, string>
}

const getCommerceLayerCustomer = async (email: string): Promise<Customer | null> => {
  try {
    const res = await fetch(`/api/commercelayer/customer/get-customer-by-email/${email}`)

    if (res.status !== 200) {
      return null
    }

    const result = await res.json()

    return result
  } catch (error) {
    return null
  }
}

const createCommerceLayerCustomer = async (email: string): Promise<Customer> => {
  const response = await fetch('/api/commercelayer/customer/create', {
    method: 'POST',
    body: JSON.stringify({
      email,
    }),
  })

  return await response.json()
}

export const createOrUpdateCustomer = async (sub: string, email: string) => {
  try {
    let customer = await getCommerceLayerCustomer(email).catch(() => null)
    if (!customer) {
      customer = await createCommerceLayerCustomer(email).catch((error) => {
        console.error(error)
        throw new Error('Failed to create customer')
      })
    }

    const response = await fetch(`/api/auth0/update-user/${sub}`, {
      method: 'POST',
      body: JSON.stringify({
        payload: { user_metadata: { cl_customer_id: customer.id } },
      }),
    })

    return await response.json()
  } catch (error) {
    console.error(error)
    return null
  }
}
